import React from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';

import About from 'pages/About';
import Contact from 'pages/Contact';
import Curriculum from 'pages/Curriculum';
import Home from 'pages/Home';
import PageNotFound from 'pages/PageNotFound';
import Pricing from 'pages/Pricing';
import Media from 'pages/Media';

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="" element={<Home />} />
      <Route path="about" element={<About />} />
      <Route path="curriculum" element={<Curriculum />} />
      <Route path="pricing" element={<Pricing />} />
      <Route path="contact" element={<Contact />} />
      <Route path="media" element={<Media />} />
      <Route path="*" element={<PageNotFound />} />
    </Route>
  )
);
